export default __webpack_public_path__ + "static/media/nice-try-meetings.ff9946b6.md";